import api from '@/api';

const resource = 'ei/notificacao';

export default {
  getNotificacoes( dados ) {
    return api.get( `${resource}`, { params: dados } );
  },

  getNotificacao( id, dados ) {
    return api.get( `${resource}/${id}`, { params: dados} );
  },

  getQuantidadeNotificacoes( dados ) {
    return api.get( `${resource}/quantidade`, { params: dados} );
  },

  postNotificacao( data ) {
    return api.post( `${resource}`, data );
  },

  putNotificacao( data ) {
    return api.put( `${resource}/${data.identificadornotificacao}`, data);
  },

  deleteNotificacao( id, dados ) {
    return api.delete(`${resource}/${id}`, { params: dados } );
  }
};
